import './MobileFeedbackPopup.css'
import ThumbUpIcon from '#/assets/thumb-up.svg?react'
import ThumbDownIcon from '#/assets/thumb-down.svg?react'
import { FeedbackType } from '#/types/feedback.ts';

interface MobileFeedbackPopupProps {
  touchPosition: { x: number; y: number };
  selectedFeedback: FeedbackType | null;
  deselecting: FeedbackType | null;
  pressedButton: FeedbackType | null;
  onFeedback: (type: FeedbackType) => void;
  onClose: () => void;
}

export function MobileFeedbackPopup({
  touchPosition,
  selectedFeedback,
  deselecting,
  pressedButton,
  onFeedback,
  onClose
}: MobileFeedbackPopupProps) {
  const handleFeedbackClick = (type: FeedbackType) => {
    if (selectedFeedback === type) {
      onFeedback(type);
      setTimeout(() => {
        onClose();
      }, 300);
      return;
    }

    onFeedback(type);
    setTimeout(() => {
      onClose();
    }, 300);
  };

  return (
    <div 
      className="mobileFeedbackPopup"
      style={{
        '--touch-x': `${touchPosition.x}px`,
        '--touch-y': `${touchPosition.y}px`
      } as React.CSSProperties}
      onClick={(e) => e.stopPropagation()}
    >
      <button
        className={`feedbackBtn ${
          deselecting === FeedbackType.POSITIVE ? 'deselecting' : 
          (pressedButton === FeedbackType.POSITIVE || (selectedFeedback === FeedbackType.POSITIVE && pressedButton !== FeedbackType.NEGATIVE)) ? 'selected' : ''
        }`}
        onClick={() => handleFeedbackClick(FeedbackType.POSITIVE)}
      >
        <ThumbUpIcon className="feedbackIcon" aria-label="thumbs up" />
      </button>
      <button
        className={`feedbackBtn ${
          deselecting === FeedbackType.NEGATIVE ? 'deselecting' : 
          (pressedButton === FeedbackType.NEGATIVE || (selectedFeedback === FeedbackType.NEGATIVE && pressedButton !== FeedbackType.POSITIVE)) ? 'selected' : ''
        }`}
        onClick={() => handleFeedbackClick(FeedbackType.NEGATIVE)}
      >
        <ThumbDownIcon className="feedbackIcon" aria-label="thumbs down" />
      </button>
    </div>
  );
} 